import { ACTION } from '@talos/kyoko';
import { useRoleAuth } from '../../../hooks';
import { useUpdateBalancesAccounts } from '../BalancesV2/useUpdateBalancesAccounts';

/**
 * Visibility for the "Adjust Market Account Position" button in position blotters.
 * Same as Balances blotter: EDIT_POSITION auth + org has BalancePublish configured.
 */
export const useShowAdjustMarketAccountPositionButton = () => {
  const { isAuthorized } = useRoleAuth();
  const { accounts } = useUpdateBalancesAccounts();

  return isAuthorized(ACTION.EDIT_POSITION) && (accounts?.length ?? 0) > 0;
};
